// @flow
import Q from 'q';

import BaseController from './base';

import { apiStatuses } from '../dictionary';

import type { IController } from '../contracts';

export default class OsagoController
	extends BaseController
	implements IController {
	
	_sendCheckRequest = (): Promise<any> => {
		return this._options.descendingSettings.sendCheckRequest()
			.then(result => {
				const { dataModel } = this._options.descendingSettings;
				dataModel.CodeSending(result.responseJSON.Status === apiStatuses.success);

				return result;
			});
	}

	_resetToInitialParams = async (): Promise<any> => {
		this._viewModel.Code('');
		this._viewModel.hasSmsBeenSent(false);
		return Q();
	}

	_sendVerifyRequest = (): Promise<any> => {
		return this._options.descendingSettings.sendVerifyRequest()
		.then(result => {
			const { dataModel } = this._options.descendingSettings;
			dataModel.CodeCorrect(result.responseJSON.Status === apiStatuses.success);

			return result;
		});
	}
}